// ---------------------------------------------------------------
// Family / shared-viewer accounts. A car owner invites another person (spouse,
// co-parent, relative) who makes their own account and adds the owner's cars via
// the per-car share code. Once the owner approves, the member gets FULL access
// to those cars — the same live tracking, alerts, chat, history and curfew the
// owner sees. Stored locally for now (moves to real backend auth at launch).
// ---------------------------------------------------------------
import { API_BASE } from './config';

const M_KEY = 'ta-members';
const S_KEY = 'ta-member-session';
const ME_KEY = 'ta-member-me';

const PROXY = !!API_BASE;
const load = () => { try { return JSON.parse(localStorage.getItem(M_KEY)) || []; } catch { return []; } };
const save = (a) => localStorage.setItem(M_KEY, JSON.stringify(a));
const cacheMe = (u) => { try { if (u) localStorage.setItem(ME_KEY, JSON.stringify(u)); else localStorage.removeItem(ME_KEY); } catch { /* ignore */ } };
const setJwt = (t) => { try { if (t) localStorage.setItem('ta-jwt', t); else localStorage.removeItem('ta-jwt'); } catch { /* ignore */ } };
const hash = (s) => { let h = 5381; for (let i = 0; i < s.length; i++) { h = ((h << 5) + h + s.charCodeAt(i)) >>> 0; } return h.toString(36); };

export function getMembers() { return load(); }

export async function createMember({ name, email, password }) {
  const e = (email || '').toLowerCase().trim();
  if (!e || !password) throw new Error('Email and password are required.');
  if (PROXY) {
    const r = await fetch(`${API_BASE}/auth/member/signup`, { method: 'POST', credentials: 'include', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ name, email: e, password }) });
    if (!r.ok) { const d = await r.json().catch(() => ({})); throw new Error(d.error || 'Could not create the account.'); }
    const u = await r.json(); cacheMe(u); setJwt(u.token); return u;
  }
  const list = load();
  if (list.some((m) => m.email === e)) throw new Error('An account with that email already exists.');
  const rec = { id: `M${Date.now()}`, name: name || '', email: e, pass: hash(password), fleet: [], createdAt: new Date().toISOString() };
  list.push(rec); save(list);
  localStorage.setItem(S_KEY, rec.id);
  return rec;
}

export async function memberLogin(email, password) {
  const e = (email || '').toLowerCase().trim();
  if (PROXY) {
    const r = await fetch(`${API_BASE}/auth/member/login`, { method: 'POST', credentials: 'include', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ email: e, password }) });
    if (!r.ok) { const d = await r.json().catch(() => ({})); throw new Error(d.error || 'Wrong email or password.'); }
    const u = await r.json(); cacheMe(u); setJwt(u.token); return u;
  }
  const m = load().find((x) => x.email === e);
  if (!m || m.pass !== hash(password)) throw new Error('Wrong email or password.');
  localStorage.setItem(S_KEY, m.id);
  return m;
}

export function memberLogout() {
  if (PROXY) { try { fetch(`${API_BASE}/auth/logout`, { method: 'POST', credentials: 'include' }); } catch { /* ignore */ } cacheMe(null); setJwt(''); return; }
  localStorage.removeItem(S_KEY);
}

export function getMemberSession() {
  if (PROXY) { try { return JSON.parse(localStorage.getItem(ME_KEY)); } catch { return null; } }
  const id = localStorage.getItem(S_KEY);
  if (!id) return null;
  return load().find((m) => m.id === id) || null;
}

export function addToFleet(memberId, deviceId) {
  const list = load(); const m = list.find((x) => x.id === memberId);
  if (m && !m.fleet.includes(deviceId)) { m.fleet.push(deviceId); save(list); }
  return m;
}
export function removeFromFleet(memberId, deviceId) {
  const list = load(); const m = list.find((x) => x.id === memberId);
  if (m) { m.fleet = m.fleet.filter((id) => id !== deviceId); save(list); }
  return m;
}
export function getFleetIds(memberId) {
  const m = load().find((x) => x.id === memberId);
  return m ? m.fleet : [];
}
